import CommonAuthLayout from "../CommonAuthLayout";
import { Typography } from "../../../components/common";
import { LoadingSpinner } from "../../../components/common/Loading";
import { useResetPasswordHook } from "./useResetPasswordHook";

export const ResetPassword = () => {
  const { handleNavigateToLogin } = useResetPasswordHook();

  return (
    <CommonAuthLayout isLogin={false} onNavigate={handleNavigateToLogin}>
      <div className="max-w-[464px] mx-auto sm:p-6 pt-2 bg-white rounded-lg flex flex-col gap-4 items-center">
        <LoadingSpinner size={32} />
        <Typography variant="p" className="text-textSecondary text-center">
          Redirecting to code sign-in...
        </Typography>
      </div>
    </CommonAuthLayout>
  );
};
